import gql from 'graphql-tag'
import { UserFragment } from 'src/graphql/fragments/UserFragment'
import {
  QuizDuration,
  QuizUserType,
  RecurrenceInput,
  SchoolDuration,
} from 'src/types/fam-graphql'

import { mutationServiceCreator } from '../../../../helpers/GraphqlHelpers'

const mutation = gql`
  mutation submitQuiz(
    $question_1: QuizUserType!
    $question_2: Boolean!
    $question_3: Int
    $question_4: Int
    $question_5: Boolean!
    $question_6: Int
    $question_7: Int
    $question_8: SchoolDuration!
    $question_9: Boolean!
    $question_9_bis: Int
    $question_10: Int
    $question_11: Boolean!
    $question_12: Int
    $question_13: Int
    $question_14: Boolean!
    $question_14_bis: Boolean!
    $question_15: RecurrenceInput
    $question_15_bis: RecurrenceInput
    $question_16: QuizDuration!
    $question_17: QuizDuration!
  ) {
    submitQuiz(
      question_1: $question_1
      question_2: $question_2
      question_3: $question_3
      question_4: $question_4
      question_5: $question_5
      question_6: $question_6
      question_7: $question_7
      question_8: $question_8
      question_9: $question_9
      question_9_bis: $question_9_bis
      question_10: $question_10
      question_11: $question_11
      question_12: $question_12
      question_13: $question_13
      question_14: $question_14
      question_14_bis: $question_14_bis
      question_15: $question_15
      question_15_bis: $question_15_bis
      question_16: $question_16
      question_17: $question_17
    ) {
      ...UserFragment
      latest_quiz {
        id
      }
    }
  }
  ${UserFragment}
`

const transformer = ({ submitQuiz }: any) => submitQuiz

type variables = {
  question_1: QuizUserType
  question_2: boolean
  question_3: number
  question_4: number
  question_5: boolean
  question_6: number
  question_7: number
  question_8: SchoolDuration
  question_9: boolean
  question_9_bis: number
  question_10: number
  question_11: boolean
  question_12: number
  question_13: number
  question_14: boolean
  question_14_bis: boolean
  question_15: RecurrenceInput
  question_15_bis: RecurrenceInput
  question_16: QuizDuration
  question_17: QuizDuration
}

export default mutationServiceCreator<variables>(mutation, transformer)
